









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

export interface selectOption {
  text: string,
  value: string
}

@Component({
  name: 'GenericDropdown',
  components: {}
})
export default class GenericDropdown extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public startingSelectedOptionValue: string

  @Prop({ default: 'success' })
  public variant: string

  @Prop()
  public label: string


  // public reactive member variables available to the html template
  public options: selectOption[] = null

  // @ts-ignore
  public selectedOptionValue: string = this.startingSelectedOptionValue

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get titleText(): string {
    const selectedOption: selectOption = this.options.find((so) => so.value === this.selectedOptionValue)
    return selectedOption ? `${selectedOption.text}` : 'Not found'
  }
  public setOptions(options: selectOption[]) {
    this.options = options
  }

  public async userChose(optionValue: string) {
    if (this.$store.state.devmode) console.log(`GenericDropdown.userChose(${optionValue})`)
    this.selectedOptionValue = optionValue
    this.$emit('changed-option', optionValue)
  }

  public async notifyChangedFromParent(option: string) {
    this.selectedOptionValue = option
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template

  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
